import { render, staticRenderFns } from "./BizBusinessinfoBusinessTypeModal.vue?vue&type=template&id=56124014&"
import script from "./BizBusinessinfoBusinessTypeModal.vue?vue&type=script&lang=js&"
export * from "./BizBusinessinfoBusinessTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports